import React, { useEffect, useState } from 'react';
import { PortableText } from '@portabletext/react';
import { client } from '@/sanity/client';

export const AboutFounderText: React.FC = () => {
	const [bio, setBio] = useState([]);

	useEffect(() => {
		const fetchBio = async () => {
			const data = await client.fetch(`*[_type == "aboutPage"][0].founder.bio`);
			setBio(data);
		};

		fetchBio();
	}, []);

	return (
		<article className='self-stretch my-auto text-md text-neutral-800 max-md:mt-10 max-md:max-w-full'>
			<PortableText
				value={bio}
				components={{
					block: {
						h1: ({ children }) => (
							<h1 className='text-3xl font-bold my-4'>{children}</h1>
						),
						h2: ({ children }) => (
							<h2 className='text-2xl font-bold my-3'>{children}</h2>
						),
						h3: ({ children }) => (
							<h3 className='text-xl font-bold my-2'>{children}</h3>
						),
						h4: ({ children }) => (
							<h4 className='text-lg font-semibold my-2'>{children}</h4>
						),
						normal: ({ children }) => <p className='mb-4'>{children}</p>,
						blockquote: ({ children }) => (
							<blockquote className='pl-4 border-l-4 border-gray-300 italic my-4'>
								{children}
							</blockquote>
						),
					},
					list: {
						bullet: ({ children }) => (
							<ul className='list-disc pl-6 mb-4'>{children}</ul>
						),
						number: ({ children }) => (
							<ol className='list-decimal pl-6 mb-4'>{children}</ol>
						),
					},
					marks: {
						strong: ({ children }) => (
							<strong className='font-bold'>{children}</strong>
						),
						em: ({ children }) => <em className='italic'>{children}</em>,
						link: ({ value, children }) => {
							const target = (value?.href || '').startsWith('http')
								? '_blank'
								: undefined;
							return (
								<a
									href={value?.href}
									target={target}
									rel={target === '_blank' ? 'noopener noreferrer' : undefined}
									className='text-blue-600 hover:underline'
								>
									{children}
								</a>
							);
						},
					},
				}}
			/>
		</article>
	);
};
